import React from 'react';
import { Input, DatePicker, Radio } from 'antd';
import Text from '../../../basicElement/Text';
import { StartBeforeType } from '../constants';
import FteRequirement from './FteRequirement';
import moment from 'moment';
import SpecificFteRequirement from './SpecificFteRequirement';

const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';

const genMomentDate = date => date ? moment(date) : null;
const genOptions = data => Object.keys(data).map(i => <Radio key={i} value={i}>{ data[i] }</Radio>);
const disabledDate = current => current ? current.valueOf() < moment().subtract(1, 'd').valueOf() : false;

const StartBeforeTypeOption = genOptions(StartBeforeType, 'radio');

export default function RequirementTypeContent(props) {
    const { params, type, data, onChange, isGivenSecondLines } = props;
    const { siteStartTime } = params;

    return (
        <div
            className="modal-content form-list"
            style={{ padding: 10, border: '1px solid #D1D1D1', borderRadius: 3 }}
        >
            <ul className="modal-list">
                {
                    type === 'before' &&
                    <li className="modal-item">
                        <div className="item-left"><Text asterisk colon>启动前类型</Text></div>
                        <div className="item-right">
                            <RadioGroup
                                value={data.requirementInfoType}
                                onChange={e => onChange(e.target.value, 'requirementInfoType')}
                            >
                                { StartBeforeTypeOption }
                                {/* <span className="clearValue" onClick={() => this.handleRemove('cashReqNodeType')}>×</span> */}
                            </RadioGroup>
                        </div>
                    </li>
                }
                {
                    isGivenSecondLines ? 
                        <SpecificFteRequirement
                            asterisk
                            data={data}
                        />
                        :
                        <FteRequirement
                            asterisk
                            params={params}
                            data={data}
                            onChange={onChange}
                        />
                }
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={false} colon>人员要求</Text></div>
                    <div className="item-right">
                        <Input
                            placeholder="请输入"
                            value={data.comment}
                            onChange={e => onChange(e.target.value, 'comment')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>预计上岗时间</Text></div>
                    <div className="item-right">
                        <DatePicker
                            format={dateFormat}
                            placeholder="请选择"
                            disabledDate={disabledDate}
                            value={genMomentDate(data.planOnDutyTime)}
                            onChange={(date, dateString) => onChange(dateString, 'planOnDutyTime')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>预计/实际启动时间</Text></div>
                    <div className="item-right">
                        <DatePicker
                            format={dateFormat}
                            placeholder="请选择"
                            disabled={!!siteStartTime}
                            disabledDate={disabledDate}
                            value={genMomentDate(data.planStartupTime)}
                            onChange={(date, dateString) => onChange(dateString, 'planStartupTime')}
                        />
                    </div>
                </li>
            </ul>
            <div style={{ fontSize: 12, color: '#ff0000', transform: 'scale(0.9)', position: 'relative', left: -18 }}>当预计/实际启动时间为空时，请先在项目计划-中心启动计划页面维护“计划site启动日期”。</div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/user/require/components/RequirementInfoContent.js